import styled from 'styled-components'
import { device } from '../../styles/Breakpoints'
import { BackdropFadeIn, ModalScrollDown, ModalReveal, ModalSlideUp } from './VSMModal.keyframes'

export const VSMModalBackdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	z-index: 10;
	animation: ${BackdropFadeIn} 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
	opacity: 1;
`

export const RecommendedReading = styled.div`
	display: flex;
	flex-direction: column;
	padding: 20px 20px;
`

export const VSMCTA = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 40px;
	text-align: center;
	color: #fff;

	button,
	a.button {
		background: transparent;
		border: 2px solid #fff;
		color: #fff;
		min-width: 170px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 3px;
		font-family: 'Source Sans Pro', sans-serif;
		font-size: 20px;
		text-decoration: none;
	}
`

export const VSMModalOverlay = styled.div`
	background-color: #fff;
	animation: ${ModalReveal} 0.9s ease-in;
`

export const VSMModalScroll = styled.div`
	overflow-y: scroll;
	/* height: 100%; */
	background-color: #fff;
	border-radius: 5px;
	position: relative;

	animation: ${ModalScrollDown(80)} 0.9s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
`

export const CloseModalButton = styled.button`
	position: absolute;
	top: -20px;
	right: 10px;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	padding: 10px;
	display: block;
	margin: 0;
	z-index: 10;
	background-color: #fff;
	box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);

	@media ${device.sm} {
		top: 10px;
		right: -20px;
	}

	&:hover {
		box-shadow: none;
	}

	> div {
		height: 2px;
		background: #000;
		width: 100%;
		transform-origin: 42% 45%;

		:first-child {
			transform: rotate(45deg);
		}

		:last-child {
			transform: rotate(-45deg);
		}
	}
`

export const SectionTitle = styled.h2`
	font-size: 20px;

	@media ${device.sm} {
		font-size: 24px;
	}
`

export const Title = styled.div`
	display: flex;
	padding: 20px;

	@media ${device.sm} {
		padding: 20px 40px;
	}
`

export const Superpower = styled.div`
	display: grid;
	grid-template-columns: 25% 75%;
	gap: 10px;
	align-items: center;
	padding: 30px 20px;
	color: #fff;

	@media ${device.sm} {
		grid-template-columns: 15% 75%;
		padding: 50px 40px;
	}

	${SectionTitle} {
		font-size: 24px;
		line-height: 1.1;
		margin-top: 10px;

		@media ${device.sm} {
			font-size: 34px;
		}
	}
`

export const SuperpowerIcons = styled.div`
	position: relative;

	img.superheroIcon {
		box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
		max-width: 85px;
		border-radius: 50%;
	}

	img.secondaryIcon {
		max-width: 40px;
		position: absolute;
		bottom: 0px;
		right: 25px;
		box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
		border-radius: 50%;
	}
`

export const DaNV = styled.div`
	display: flex;
	flex-direction: column;
	padding: 20px;
	justify-content: center;
	align-items: center;

	p {
		font-size: 12px;
	}

	@media ${device.sm} {
		padding: 40px 40px;
		justify-content: flex-start;
		align-items: flex-start;
	}
`

export const VendorIcons = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 150px);
	/* grid-template-rows: repeat(auto-fill, 50px); */
	grid-auto-rows: 50px;
	gap: 10px;
	padding-top: 20px;

	@media ${device.sm} {
		grid-template-columns: repeat(4, 200px);
		grid-template-rows: repeat(2, 50px);
	}
`

export const VendorGridItem = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	img {
		max-width: 120px;
		height: 20px;
	}

	@media ${device.sm} {
		justify-content: flex-start;

		img {
			max-width: 125px;
			height: 20px;
		}
	}

	@media ${device.md} {
		&.submit-a-vendor {
			grid-column-start: 4;
			grid-row-start: 2;
		}
	}
`

export const Points = styled.div`
	flex: 1 0 50%;

	ul {
		margin-top: 20px;
		padding-inline-start: 17px;
		padding-right: 20px;

		li {
			margin-bottom: 10px;
			font-size: 14px;
		}
	}
`

export const UsesAndImprovements = styled.div`
	display: flex;
	flex-direction: column;
	padding: 20px;
	justify-content: center;
	align-items: flex-start;

	${Points} {
		padding-bottom: 20px;

		@media ${device.sm} {
			padding-bottom: unset;
		}
	}

	@media ${device.sm} {
		flex-direction: row;
		padding: 20px 40px;
	}
`

export const ThreeQuarter = styled.div`
	width: 100%;
	margin-bottom: 20px;

	@media ${device.sm} {
		width: 75%;
	}
`

export const Newspaper = styled.div`
	column-count: 1;
	column-gap: 2em;
	margin-top: 20px;

	ol {
		margin-top: 0;
		padding-inline-start: 15px;

		li {
			font-size: 14px;
			padding-left: 7px;
			margin-bottom: 10px;

			&::marker {
				font-weight: 700;
			}
		}
	}

	@media only screen and (min-width: 768px) {
		column-count: 2;
	}
`

export const TopBar = styled.div`
	position: sticky;
	z-index: 1;
	padding-left: 3em;
	width: 100%;
	color: #fff;
`

export const ModalTab = styled.span`
	display: flex;
	position: relative;
	justify-content: center;
	align-items: center;
	width: 8em;
	padding: 8px 10px 0;
	color: #fff;
	text-transform: uppercase;
	font-size: 13px;
	letter-spacing: 0.3em;
	font-weight: 600;
	font-family: 'Source Sans Pro', sans-serif;

	&:before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 7px;
		left: 0;
		z-index: -1;
		border-bottom: none;
		border-radius: 0.4em 0.4em 0 0;
		transform: scale(1.2, 1.3) perspective(0.5em) rotateX(5deg);
		transform-origin: top;
	}
`

export const CapHeader = styled.p`
	text-transform: uppercase;
	letter-spacing: 0.4em;
	font-weight: 600;
	font-size: 11px;
	font-family: 'Source Sans Pro', sans-serif;
	margin: 0;
`

export const Example = styled.div`
	display: flex;
	flex-direction: column;
	background: #f6f6f6;
	padding: 20px;

	p {
		font-size: 16px;
	}

	${CapHeader} {
		font-size: 11px;
	}

	@media ${device.sm} {
		padding: 20px 40px;
	}
`

export const VSMRRGridColumn = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	padding-bottom: 50px;

	@media ${device.sm} {
		padding-bottom: 100px;
	}
`

export const VSMRRGridMedia = styled.div`
	img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
`

export const VSMRRGridContent = styled.div`
	height: 100%;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;

	button {
		max-width: 175px;
		position: absolute;
		bottom: 20px;
		margin: 0;
	}

	p {
		font-family: 'Source Sans Pro', sans-serif;
		font-size: 16px;
		font-weight: 600;
		line-height: 1.2;
	}
`

export const VSMRRGridLink = styled.div`
	position: absolute;
	bottom: -50px;
	width: 100%;
	display: flex;
	height: 50px;

	a {
		position: relative;
		bottom: 0;
	}

	button {
		position: relative;
		bottom: 0;
	}
`

export const VSMFourColumnRow = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;

	@media ${device.xs} {
		grid-template-columns: 1fr 1fr;
	}

	@media ${device.sm} {
		grid-template-columns: 1fr 1fr 1fr 1fr;
		gap: 20px;
	}
`

export const VSMModalWrapper = styled.div`
	width: 90vw;
	max-width: 100%;
	position: fixed;
	left: 50%;
	top: 50%;
	z-index: 10;
	transform: translate(-50%, -50%);
	height: 70vh;
	animation: ${ModalSlideUp} 0.7s ease;

	a {
		text-decoration: underline;
	}

	@media ${device.sm} {
		width: 85vw;
		max-width: 914px;
	}

	@media ${device.md} {
		width: 914px;
	}

	&.ideate {
		${ModalTab} {
			color: #000;

			&:before {
				background: #ffc322;
			}
		}

		${VSMModalScroll} {
			border-top: 7px solid #ffc322;
		}

		${Title}, ${DaNV} {
			background-color: #fff9e9;
		}

		${Superpower}, ${VSMCTA} {
			background: #ffc322;
			color: #000;
		}

		${Points} {
			ul {
				li {
					&::marker {
						color: #ffc322;
					}
				}
			}
		}

		${VSMCTA} {
			button,
			a.button {
				color: #000;
				border: 2px solid #000;
				&:hover {
					background-color: #fff9e9;
				}
			}
		}

		${CloseModalButton} {
			border: 2px solid #ffc322;

			&:hover {
				background-color: #fff9e9;
			}
		}
	}

	&.create {
		${ModalTab} {
			&:before {
				background: #a049ca;
			}

			@media ${device.sm} {
				left: 150px;
			}
		}

		${VSMModalScroll} {
			border-top: 7px solid #a049ca;
		}

		${Title}, ${DaNV} {
			background-color: #f0e6f5;
		}

		${Superpower}, ${VSMCTA} {
			background: #a049ca;
		}

		${Points} {
			ul {
				li {
					&::marker {
						color: #a049ca;
					}
				}
			}
		}

		${VSMCTA} {
			button,
			a.button {
				&:hover {
					background-color: #f0e6f5;
					color: #000;
					border: 2px solid #000;
				}
			}
		}

		${CloseModalButton} {
			border: 2px solid #a049ca;

			&:hover {
				background-color: #f0e6f5;
			}
		}
	}

	&.release {
		${ModalTab} {
			&:before {
				background: #eb4a10;
			}

			@media ${device.sm} {
				left: 300px;
			}
		}

		${VSMModalScroll} {
			border-top: 7px solid #eb4a10;
		}

		${Title}, ${DaNV} {
			background-color: #fff2ed;
		}

		${Superpower}, ${VSMCTA} {
			background: #eb4a10;
		}

		${Points} {
			ul {
				li {
					&::marker {
						color: #eb4a10;
					}
				}
			}
		}

		${VSMCTA} {
			button,
			a.button {
				&:hover {
					background-color: #fff2ed;
					color: #000;
					border: 2px solid #000;
				}
			}
		}

		${CloseModalButton} {
			border: 2px solid #eb4a10;

			&:hover {
				background-color: #fff2ed;
			}
		}
	}

	&.operate {
		${ModalTab} {
			&:before {
				background: #00abb3;
			}

			@media ${device.sm} {
				left: 450px;
			}
		}

		${VSMModalScroll} {
			border-top: 7px solid #00abb3;
		}

		${Title}, ${DaNV} {
			background-color: #f1fefe;
		}

		${Superpower}, ${VSMCTA} {
			background: #00abb3;
		}

		${Points} {
			ul {
				li {
					&::marker {
						color: #00abb3;
					}
				}
			}
		}

		${VSMCTA} {
			button,
			a.button {
				&:hover {
					background-color: #f1fefe;
					color: #000;
					border: 2px solid #000;
				}
			}
		}

		${CloseModalButton} {
			border: 2px solid #00abb3;

			&:hover {
				background-color: #f1fefe;
			}
		}
	}
`
